import { BoringContainer } from "./styles";

export function BlindDuelEula() {
  return (
    <BoringContainer>
      <strong>Terms &amp; Conditions</strong>
      <br />
      <p>
        These terms and conditions apply to the BlindDuel app (hereby referred
        to as "Application") for mobile devices that was created by Yuriy
        Tolstykh (hereby referred to as "Service Provider") as a Free service.
      </p>
      <br />
      <p>
        Upon downloading or utilizing the Application, you are automatically
        agreeing to the following terms. It is strongly advised that you
        thoroughly read and understand these terms prior to using the
        Application.
      </p>
      <br />
      <p>
        Unauthorized copying, modification of the Application, any part of the
        Application, or our trademarks is strictly prohibited. Any attempts to
        extract the source code of the Application, translate the Application
        into other languages, or create derivative versions are not permitted.
        All trademarks, copyrights, database rights, and other intellectual
        property rights related to the Application remain the property of the
        Service Provider.
      </p>
      <br />
      <strong>How the Application Works</strong>
      <p>
        BlindDuel is a two-player local party game: two phones connect
        directly to each other over Bluetooth/Wi-Fi Direct (no game server is
        involved) and each player aims blind, using only their own phone's
        compass and step sensors, to sense roughly where the other player is
        standing nearby. Neither screen shows the opponent's exact location —
        this imprecision is an intentional part of the gameplay. The
        Application is intended to be played by two consenting players in
        person, in a safe, open physical space of their choosing. The Service
        Provider is not responsible for the physical environment in which you
        choose to play, and you are solely responsible for ensuring the space
        is safe for movement. If the connection between the two devices
        briefly drops mid-match, the Application will attempt to
        automatically reconnect for a short window before ending the session.
        After a match, players may optionally watch a local replay of that
        match on the device that recorded it; this replay is not shared or
        transmitted anywhere and is not available to the opposing player's
        device.
      </p>
      <br />
      <p>
        The Application stores only the minimal data described in the Privacy
        Policy in order to provide the Service, and that data is not retained
        beyond the current game session. It is your responsibility to
        maintain the security of your phone and access to the Application.
        The Service Provider strongly advises against jailbreaking or rooting
        your phone, which involves removing software restrictions and
        limitations imposed by the official operating system of your device.
        Such actions could expose your phone to malware, viruses, malicious
        programs, compromise your phone's security features, and may result
        in the Application not functioning correctly or at all.
      </p>
      <br />
      <strong>Permissions and Device Features</strong>
      <p>
        By using the Application, you acknowledge and agree that the
        Application may request access to the following device capabilities:
      </p>
      <ul>
        <li>
          <strong>Camera</strong> — used only to scan the QR code displayed by
          the other player's device in order to connect two devices for a
          match. No photos or video are stored or transmitted.
        </li>
        <li>
          <strong>Nearby devices / Bluetooth and, on older Android versions,
          location</strong> — required by the Android Nearby Connections API
          to discover and connect to the other player's device. The
          Application does not read or use your GPS location even where
          location permission is required by the operating system for
          Bluetooth/Wi-Fi peer discovery to function.
        </li>
        <li>
          <strong>Physical activity</strong> — used to read step-detector
          sensor events for the Application's movement-estimation gameplay
          mechanic. This permission is optional; if denied, the Application
          remains fully playable with a reduced gameplay mechanic.
        </li>
        <li>
          <strong>Vibration</strong> — used to provide haptic feedback when
          you are hit during a match.
        </li>
        <li>
          <strong>Internet / Wi-Fi state</strong> — required by the Nearby
          Connections API to establish the local peer-to-peer link between the
          two devices during a match.
        </li>
      </ul>
      <p>
        You may revoke any of these permissions at any time through your
        device's system settings. Revoking a permission may disable the
        corresponding feature in the Application.
      </p>
      <br />
      <strong>Third-Party Services</strong>
      <p>
        The Application uses Google Play Services (Nearby Connections API and
        ML Kit barcode scanning) to connect two players' devices directly to
        each other and to scan the QR pairing code. These components run
        on-device and are governed by{" "}
        <a
          href="https://policies.google.com/terms"
          target="_blank"
          rel="noopener noreferrer"
        >
          Google's Terms of Service
        </a>
        .
      </p>
      <p>
        The Service Provider accepts no liability for any loss, direct or
        indirect, that you experience as a result of relying entirely on
        third-party functionality within the Application, or as a result of
        the Application's own intentionally imprecise gameplay mechanics.
      </p>
      <br />
      <strong>Internet Connectivity</strong>
      <p>
        Please be aware that the Service Provider does not assume
        responsibility for certain aspects. The Application requires an
        active Bluetooth and/or Wi-Fi connection between the two devices to
        function; it does not require internet access to a remote server.
        The Service Provider cannot be held responsible if the Application
        does not function at full capacity due to device hardware limitations
        or environmental interference with Bluetooth/Wi-Fi connectivity.
      </p>
      <br />
      <p>
        The Service Provider cannot always assume responsibility for your
        usage of the Application. For instance, it is your responsibility to
        ensure that your device remains charged. If your device runs out of
        battery and you are unable to access the Service, the Service
        Provider cannot be held responsible.
      </p>
      <br />
      <strong>Updates and Termination</strong>
      <p>
        The Service Provider may wish to update the Application at some
        point. The Application is currently available on Android — the
        requirements for the system (and for any additional systems the
        Service Provider decides to extend the availability of the
        Application to) may change, and you will need to download the updates
        if you want to continue using the Application. The Service Provider
        does not guarantee that it will always update the Application so that
        it is relevant to you and/or compatible with the particular operating
        system version installed on your device. However, you agree to always
        accept updates to the Application when offered to you. The Service
        Provider may also wish to cease providing the Application and may
        terminate its use at any time without providing termination notice to
        you. Unless they inform you otherwise, upon any termination, (a) the
        rights and licenses granted to you in these terms will end; (b) you
        must cease using the Application, and (if necessary) delete it from
        your device.
      </p>
      <br />
      <strong>Changes to These Terms and Conditions</strong>
      <p>
        The Service Provider may periodically update their Terms and
        Conditions. Therefore, you are advised to review this page regularly
        for any changes. The Service Provider will notify you of any changes
        by posting the new Terms and Conditions on this page.
      </p>
      <br />
      <p>These terms and conditions are effective as of 2026-08-19</p>
      <br />
      <strong>Contact Us</strong>
      <p>
        If you have any questions or suggestions about the Terms and
        Conditions, please do not hesitate to contact the Service Provider at
        eataburrita@gmail.com.
      </p>
    </BoringContainer>
  );
}
